import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: relays mutation plugin deletions to remove actions here
 */
export const removeOnDeletion = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.plugins.dataOperationPlugin.feature.actions.delete.success
      .observe()
      .pipe(
        rxjs.map(action =>
          feature.actions.remove.from(action).create({
            ids: [...action.data.request.ids],
          }),
        ),
      ),
)
